export default "__VITE_ASSET__swInxdM5__"